/** @module csi/widget/_svg/ShapeHorizontalDistribute */
define([
	"./_ShapeDistribute",
	"./PluginFactory"
], function(_ShapeDistribute,PluginFactory) {

	return PluginFactory.declare(_ShapeDistribute, {
		iconClass: "csiActionIcon svgIconHDistribute",
		pluginName: "shapeDistributeHorizontal",
		title: "CanvasShapeDistributeHorizontal",
		bHorizontal: true
	});
});
